import { Box, Button, IconButton, Modal, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SSOForm from './SSOForm';
import SSOEditor from './SSOEditor';
import SSOInfo from './SSOInfo';
import { OPTIONS } from '../../features/manageSSO/manageSSOUtils';
import CloseIcon from '@mui/icons-material/Close';
import { postRegistration } from '../../features/manageSSO/manageSSOService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { LoadingButton } from '@mui/lab';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


interface Props {
    open: boolean,
    selectedData?: any,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    init: () => void
}


function CreateNewReg({ open, selectedData, setOpen, init }: Props) {
    const [currTab, setCurrTab] = useState<string>("form");
    const [values, setValues] = useState<Record<string, any>>({});
    const [file, setFile] = useState<File | null>(null);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);

    async function handleSave() {
        setSaveLoad(true);
        try {
            await postRegistration(values);
            openPopup("Success", `${selectedData ? 'Data Updated Successfully' : 'Data Added Successfully'}`, init)
            handleClose();
        } catch (error: any) {
            openPopup("Error", error.data.message);
            console.error(error);
        } finally {
            setSaveLoad(false);
            
        }
    }

    function handleValuesChange(newValues: Record<string, any>) {
        setValues(newValues);
    }

    function renderTabContent() {
        switch (currTab) {
            case "form": return <SSOForm handleChange={handleValuesChange} values={values} options={OPTIONS.saml} file={file} setFile={setFile} />
            case "all": return <SSOEditor value={values} handleChange={handleValuesChange} />
            case "info": return <SSOInfo link={'https://redmine.sellina.in/projects/channelkart/wiki/SAML'} />
            default: <></>
        }
    }

    function resetToDefaultValue() {
        let newVals: Record<string, any> = {};
        OPTIONS.saml.forEach((option: any) => {
            const val = option.defaultValue;
            newVals[option.id] = val;

        })
        setValues(newVals);
    }

    const handleClose=()=>{
        setValues({});
        setFile(null);
        setCurrTab('form');
        setOpen(false); 
    }


    useEffect(() => {
        
        if(!open) return;
        
        if (selectedData) {
            setValues(selectedData);
            return;
        } else {
            resetToDefaultValue();
        }
    }, [selectedData, open]);



    return (
        <Modal
            open={open}
            onClose={() => { handleClose() }}
        >
            <Box sx={style}>
                <IconButton onClick={() => handleClose()} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                    <CloseIcon />
                </IconButton>

                <Tabs value={currTab} onChange={(_, newVal) => { setCurrTab(newVal) }} centered>
                    <Tab value={"form"} label="FORM" />
                    <Tab value={"all"} label="ALL" />
                    <Tab value={"info"} label="INFO" />
                </Tabs>
                <div className='new-reg-tab-content-wrapper'></div>
                {
                    renderTabContent()
                }
                <div className='new-reg-footer'>
                    {
                        currTab === "form" && <Button
                            variant='contained'
                            onClick={() => setCurrTab("all")}
                        >Next
                        </Button>
                    }
                    {
                        currTab === "all" && <LoadingButton
                            loadingPosition="start"
                            variant='contained'
                            onClick={handleSave}
                            loading={saveLoad}
                        ><span>Save</span>
                        </LoadingButton>
                    }
                </div>
            </Box>
        </Modal>
    )
}

export default CreateNewReg